


































































import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import SpaInput from '@/components/atoms/Input.vue'
import { ApplicablePoint } from '@/models/point/applicable-point'
import { formatPoint, pointUnit } from '@/util/format'

@Component({
  components: {
    SpaInput,
  },
})
/**
 * ユーザからの入力値はこのコンポーネントの内部状態として扱われており、外部からも特に関心がなかったが、
 * https://github.com/my-color/front/issues/6487 の対応以降、入力値の状態や入力値にもとづくメッセージ表示状態を、外部の状態・イベントと連動させる必要が出てきた。
 * いったんは内部状態としたままwatchで処理しているが、P/Cパターンに沿って、内部状態を廃止し、
 * ポイント適用のためのコンポーネント群が必要とするビューモデルの集約を上位コンポーネントで管理するように変更したい。
 */
export default class InputApplyingPoint extends Vue {
  @Prop({ required: true })
  applicablePoint: ApplicablePoint

  @Prop({ default: false })
  isLoading: boolean

  /**
   * 実際に適用されているポイント
   */
  @Prop({ required: true })
  appliedPoint: number

  /**
   * 入力されている(≠適用されている)ポイント
   * characters like 'e', '-' can be this.input,
   * but due to the validation in the html input these values are considered as empty string.
   */
  value = 0 as number | ''

  errorStatus: ErrorStatus = {
    valueIsNotApplicable: false,
  }

  readonly pointUnit = pointUnit
  readonly formatPoint = formatPoint

  async created() {
    this.value = this.appliedPoint
  }

  get limit(): number {
    return this.applicablePoint.toNumber()
  }

  @Watch('applicablePoint')
  assureWithinLimit() {
    if (!this.applicablePoint.contain(this.value)) {
      this.value = 0
      this.apply(this.value)
    }
  }

  @Watch('appliedPoint')
  assureInputPointEqualToAppliedPoint() {
    this.value = this.appliedPoint

    this.overwriteErrorStatus({
      valueIsNotApplicable: false,
    })
  }

  @Emit()
  apply(value: number | '') {
    this.overwriteErrorStatus({
      valueIsNotApplicable: false,
    })

    return value
  }

  @Emit()
  input(): void {
    this.overwriteErrorStatus({
      valueIsNotApplicable: !this.inputValueIsValid(),
    })

  }

  onApply() {
    if (!this.inputValueIsValid()) {
      this.overwriteErrorStatus({
        valueIsNotApplicable: true,
      })

      return
    }

    this.apply(this.value)
  }

  inputValueIsValid(): boolean {
    if (!this.applicablePoint.contain(this.value)) {

      return false
    }

    return true
  }

  onInput() {
    this.input()
  }

  overwriteErrorStatus(overwrite: Partial<ErrorStatus>) {
    this.errorStatus = {
      ...this.errorStatus,
      ...overwrite,
    }
  }
}

interface ErrorStatus {
  valueIsNotApplicable: boolean
}
